module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-02-a5e1743a781a9b6ee5805a009a199220.svg";